<div class="docs-search" (keydown)="onKeydown($event)">
  <div class="docs-search__field">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="7" cy="7" r="5.25" stroke="currentColor" stroke-width="1.5"/>
      <path d="M14 14L11 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
    <input
      #input
      type="text"
      placeholder="Search the docs…"
      [(ngModel)]="query"
      (ngModelChange)="onQueryChange()"
      autocomplete="off"
    />
  </div>

  <div class="docs-search__results">
    @if (!results.length) {
      <p class="docs-search__empty">No matches for &ldquo;{{ query }}&rdquo;.</p>
    }
    @for (entry of results; track entry.page + (entry.fragment ?? ''); let i = $index) {
      <button
        type="button"
        class="docs-search__result"
        [class.docs-search__result--active]="i === activeIndex"
        (mouseenter)="activeIndex = i"
        (click)="select(entry)"
      >
        <span class="docs-search__result-icon">
          @switch (iconType(entry)) {
            @case ('endpoint') {
              <span class="endpoint-badge endpoint-badge--post">POST</span>
            }
            @case ('anchor') {
              <span class="docs-search__hash">#</span>
            }
            @case ('page') {
              <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M1 2.5A1.5 1.5 0 012.5 1H7a1 1 0 011 1v11a.75.75 0 01-1.28.53A3.98 3.98 0 004 12.5H2.5A1.5 1.5 0 011 11V2.5Z" fill="currentColor"/><path d="M15 2.5A1.5 1.5 0 0013.5 1H9a1 1 0 00-1 1v11a.75.75 0 001.28.53A3.98 3.98 0 0112 12.5h1.5A1.5 1.5 0 0015 11V2.5Z" fill="currentColor"/></svg>
            }
          }
        </span>
        <span class="docs-search__result-body">
          <span class="docs-search__result-header">
            @for (part of matchParts(entry.header); track $index) {
              <span [class.docs-search__match]="part.hit">{{ part.text }}</span>
            }
          </span>
          @if (query.trim()) {
            <span class="docs-search__result-snippet">
              @for (part of matchParts(entry.content); track $index) {
                <span [class.docs-search__match]="part.hit">{{ part.text }}</span>
              }
            </span>
          }
          <span class="docs-search__result-crumbs">
            @for (crumb of entry.breadcrumbs; track $index; let last = $last) {
              {{ crumb }}@if (!last) { <span class="docs-search__crumb-sep">&rsaquo;</span> }
            }
          </span>
        </span>
      </button>
    }
  </div>

  <div class="docs-search__footer">
    <span class="docs-search__hint">
      <kbd>&uarr;</kbd><kbd>&darr;</kbd> Navigate
    </span>
    <span class="docs-search__hint">
      <kbd>&crarr;</kbd> Select
    </span>
    <span class="docs-search__hint">
      <kbd>Esc</kbd> Close
    </span>
  </div>
</div>
